// src/utils/numberToLetters.js
export const duiToLetters = (dui) => {
  const digits = ["CERO", "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE"];
  return dui.replace(/[^0-9]/g, '').split('').map(d => digits[parseInt(d)]).join(' ') + ' guion ' + digits[parseInt(dui.split('-')[1] || 0)];
};

// Puedes usar una librería como 'numero-a-letras' o una función simple para montos
export const formatCurrencyLetters = (num) => {
  // Lógica para convertir monto a letras (ej: CIEN DÓLARES EXACTOS)
  return "CIEN DÓLARES EXACTOS";
};